//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Panel from "../member-activation/components/panel.vue";
export default {
  components: {
    Panel: Panel
  },
  props: {
    loginOutTip: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      visible: false,
      time: 5
    };
  },
  mounted: function mounted() {
    var _this = this;

    var count = function count() {
      _this.timer = setTimeout(function () {
        _this.timer = null;
        clearTimeout(_this.timer);
        console.log(_this.time); // 时间到重新开始

        if (--_this.time > 0) {
          count();
        } else {
          _this.close();
        }
      }, 1000);
    };

    count();
  },
  methods: {
    // destroyElement() {
    //     console.log("close")
    //     this.$el.removeEventListener("transitionend", this.destroyElement);
    //     this.$destroy(true);
    //     this.$el.parentNode.removeChild(this.$el);
    //     window.localStorage.clear()
    //     window.sessionStorage.clear()
    //     window.location.reload(true)
    // },
    close: function close() {
      if (process.env.NODE_ENV === 'development') return;
      this.visible = false;
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.reload(true);
    }
  }
};